module.exports = __webpack_public_path__ + "img/web_01_2.f9c91891.jpg";